import {
  Avatar,
  Box,
  Chip,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';
import {
  allJuegosAction,
  deleteJuegosAction,
  setActivoJuegosAction,
} from '../JuegosAction';
import { PARAMS_JUEGOS } from '../JuegosReducer';
import ExpandedJuegosComponent from './ExpandedJuegos';

const ListadoJuegos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const torneosStore = Redux.useSelector((state) => state.torneos);
  const juegosStore = Redux.useSelector((state) => state.juegos);
  const equiposStore = Redux.useSelector((state) => state.equipos);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  async function getData(idTorneo) {
    const payload = {
      ...juegosStore.params,
      idTorneo,
    };
    dispatch({ type: PARAMS_JUEGOS, payload });
    if (juegosStore.all && juegosStore.all.length === 0) {
      await allJuegosAction(dispatch, payload);
    }
  }

  React.useEffect(() => {
    const fetchData = async () => {
      if (torneosStore.activo || equiposStore.activo) {
        await allJuegosAction(dispatch, {
          idEquipo: equiposStore.activo?.id,
          idTorneo: torneosStore.activo.id,
        });

        getData(torneosStore.activo?.id);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (torneosStore.all.length === 1) {
      getData(torneosStore.all[0].id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [torneosStore.all]);

  React.useEffect(() => {
    const rowsData = [];
    juegosStore.all.forEach((el) => {
      rowsData.push({
        ...el,
        ronda: el.ronda.nombre,
        estatus: el.estatus.nombre,
      });
    });
    setRows(rowsData);
  }, [juegosStore.all]);

  const _handleEditClick = async (id) => {
    const data = juegosStore.all.find((el) => el.id === id);
    await setActivoJuegosAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteJuegosAction(
      { dispatch, notify },
      juegosStore.activo.id,
      juegosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  function getDataStore(id) {
    return juegosStore.all.find((el) => el.id === id);
  }

  const cardEquipo = (equipo, res, left) => (
    <Stack direction="row" spacing={1} alignItems="center">
      {left && (
        <Avatar
          alt={equipo.imagen.nombre}
          sx={{ width: 30, height: 30 }}
          src={getFilesArchivos(equipo.imagen)}
        />
      )}
      {!left && (
        <Typography
          variant="body1"
          color="initial"
          align="center"
          sx={{ fontWeight: 'bold' }}
        >
          {res}
        </Typography>
      )}
      <Typography variant="body1" color="initial">
        {equipo.nombre}
      </Typography>
      {left && (
        <Typography
          variant="body1"
          color="initial"
          align="center"
          sx={{ fontWeight: 'bold' }}
        >
          {res}
        </Typography>
      )}
      {!left && (
        <Avatar
          alt={equipo.imagen.nombre}
          sx={{ width: 30, height: 30 }}
          src={getFilesArchivos(equipo.imagen)}
        />
      )}
    </Stack>
  );

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.equipos.name,
      label: CONST.equipos.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Box>
              <Stack direction="row" spacing={1} alignItems="center">
                {value[0] &&
                  cardEquipo(value[0].equipo, value[0].resultado, true)}
                <div style={{ width: '50px' }}>
                  <Typography
                    variant="body1"
                    color="initial"
                    align="center"
                    sx={{ fontWeight: 'bold', color: BLUE_COLOR }}
                  >
                    VS
                  </Typography>
                </div>
                {value[1] &&
                  cardEquipo(value[1].equipo, value[1].resultado, false)}
              </Stack>
            </Box>
          );
        },
      },
    },
    {
      name: CONST.fechaHora.name,
      label: CONST.fechaHora.tag,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.ronda.name,
      label: CONST.ronda.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.grupo.name,
      label: CONST.grupo.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   name: CONST.deporte.name,
    //   label: CONST.deporte.label,
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Typography
    //         // onClick={() => _handleEditClick(tableMeta.rowData[0])}
    //         >
    //           {value.nombre}
    //         </Typography>
    //       );
    //     },
    //   },
    // },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              {/* <BotonComponent
                click={async () => {
                  await setActivoJuegosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  history.push(ROUTES.panelJuegos.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de juego"
              /> */}
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={() => {
                  setActivoJuegosAction(
                    dispatch,
                    getDataStore(tableMeta.rowData[0]),
                  );
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  window.open(value.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    responsive: 'scroll',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      const data = juegosStore.all.find((el) => el.id === rowData[0]);
      return <ExpandedJuegosComponent data={data} rowData={rowData} />;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={juegosStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title="Listado"
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {juegosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{juegosStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoJuegos;
